import React, { useState, useEffect } from 'react';
// import ReactDOM from 'react-dom';
// import { connect } from 'react-redux';
import Tools from '../tools';
import { Button, Container, Modal, Row, Col, Form, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import API from '../api';
import { Cookies, withCookies } from 'react-cookie';
import Enums from '../enums'

// import { useMappedState, useDispatch } from 'redux-react-hook';

export default withCookies(function IndexApp(props) {
    const [isFetched, setIsFetched] = useState(false);
    const [isInit, setIsInit] = useState(false);
    const [userData, setUserData] = useState(null);
    const [testMemData, setTestMemData] = useState(null);
    const [tmpMobile, setTmpMobile] = useState(null);
    const [isShowPwdPanel, setIsShowPwdPanel] = useState(false)
    const [isShowMobilePanel, setIsShowMobilePanel] = useState(false)
    const [pwdTmpData, setPwdTmpData] = useState({})
    const [isAdmin, setIsAdmin] = useState(1);
    const [transactionRecord, setTransactionRecord] = useState(null);

    useEffect(() => {
        console.log("updated", isFetched);
        if (false == isFetched) {
            // console.log(this);
            // console.log(props);
            API.init({ props });
            Tools.init();
            getData();
        }
        setIsFetched(true);
    }, [isFetched]);

    function getData() {
        let tmpData = {
        };
        API.GetCustomerInfo(tmpData).
            then(onDataUpdated);

        API.GetTestingMembers({}).
            then(onTestMemUpdated);
    }

    function onDataUpdated(data) {
        setIsAdmin(API.getIsAdmin());
        // console.log(data);
        if (data) {
            if (data.code == "24014") {
                alert(data.msg);
                props.history.push(API.login_page);
            }
            // {msg: "No login", code: "24014"}
            setUserData(data);
            props.cookies.set('usr', data.display_name, { path: '/' });
        }
        setIsInit(true);
    }

    function onTestMemUpdated(data) {
        setIsAdmin(API.getIsAdmin());
        console.log(data);
        if (data) {
            setTestMemData(data);
        }
        setIsInit(true);
    }

    function onPwdSend() {
        let tmpData = {
            ...pwdTmpData,
            "account_id": userData.account_id
        }
        API.ChangePassword(tmpData).
            then((data) => {
                if (data) {
                    if (data.code == 22000) onHidePwd();
                    alert(data.msg)
                } else {
                    alert("Server error");
                    console.log(data);
                }
            });
    }

    function onMobileSend() {
        let header = {
            ty: 0
        };
        let tmpBody = {
            ...testMemData
        };

        if (null == tmpMobile || tmpMobile.length == 0) {
            tmpBody.test_phone = [];
        } else {
            if (tmpBody.test_phone.length == 0) {
                tmpBody.test_phone = [
                    { phone_numbers: [], group_name: "aa" }
                ];
            }
            tmpBody.test_phone[0].phone_numbers = tmpMobile.split(",").map((x) => ({ name: "aa", num: x }));
        }
        console.log(tmpBody);

        API.AddTestingMembers(header, tmpBody).
            then((data) => {
                if (data) {
                    if (data.code == 22000) {
                        onHideMobile();
                        getData();
                    }
                    alert(data.msg);
                } else {
                    alert("Server error");
                    console.log(data);
                }
            });
    }

    function onClickResetPwd(e) {
        e.stopPropagation();
        e.preventDefault();
        setPwdTmpData({});
        setIsShowPwdPanel(true);
        setIsShowMobilePanel(false);
    }

    function getMobile() {
        try {
            return (testMemData
                && testMemData.test_phone
                && testMemData.test_phone.length > 0
                && testMemData.test_phone[0].phone_numbers)
                ? testMemData.test_phone[0].phone_numbers.map(x => x.num).join(",") : ""
        } catch (e) {
            return "";
        }
    }

    function onAddPhone(e) {
        e.stopPropagation();
        e.preventDefault();
        console.log("onAddPhone")
        setTmpMobile(getMobile());
        setIsShowPwdPanel(false);
        setIsShowMobilePanel(true);
    }

    function onClickTransactionRecord(e) {
        e.stopPropagation();
        e.preventDefault();
        console.log("onClickTransactionRecord")

        let tmpBody = {
            // start_time:
            // end_time
        };

        API.GetTransactionRecord(tmpBody).
            then((data) => {
                if (data) {
                    console.log(data);
                    if (data.data) {
                        setTransactionRecord(data.data);
                    }
                    else if (data.msg) alert(data.msg);
                } else {
                    alert("Server error");
                    console.log(data);
                }
            });
    }


    function rednerUser() {
        return (
            <Form>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={4} md={3}>ID</Form.Label>
                    <Form.Label column sm={8} md={5}>{userData ? userData.account_id : ""}</Form.Label>
                </Form.Group>
                {/* <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={4} md={3}>Email</Form.Label>
                    <Col column sm={8} md={5}>
                        <Form.Control type="email" placeholder="Email" value={userData ? userData.email : ""} />
                    </Col>
                </Form.Group> */}

                <Form.Group as={Row} controlId="formHorizontalPassword">
                    <Form.Label column sm={4} md={3}>Password</Form.Label>
                    <Col column sm={8} md={5}>
                        <Form.Control type="password" placeholder="Password" value={userData ? 1234567 : ""} />
                    </Col>
                    <Form.Label column sm={{ span: 4, offset: 4 }} md={{ span: 4, offset: 0 }}><Link onClick={onClickResetPwd}>重設密碼</Link></Form.Label>
                </Form.Group>

                <Form.Group as={Row} controlId="formHorizontalPhone">
                    <Form.Label column sm={4} md={3}>綁定手機</Form.Label>
                    <Form.Label column sm={8} md={5} className="overflow-break-word">{getMobile()}</Form.Label>
                    <Form.Label column sm={{ span: 4, offset: 4 }} md={{ span: 4, offset: 0 }}><Link onClick={onAddPhone}>新增手機</Link></Form.Label>
                </Form.Group>
            </Form>
        )
    }

    function getType() {
        if (!userData || null == userData.is_incub_member || null == userData.is_normal_member) return "";
        if (1 == userData.is_incub_member) return "孵化器";
        if (1 == userData.is_normal_member) return "點數儲值";
        return "";
    }
    function getInterval() {
        if (!userData || !userData.activate_at || !userData.deactivate_at) return "";
        return new Date(userData.activate_at).toISOString().slice(0, 10)
            + " ~ " + new Date(userData.deactivate_at).toISOString().slice(0, 10);
    }

    function rednerCompany() {
        return (
            <Form className="mb-4">
                <Form.Group as={Row}>
                    <Form.Label column sm={4} md={3}>名稱：</Form.Label>
                    <Form.Label column sm={8} md={9}>{userData ? userData.inc_name : ""}</Form.Label>
                </Form.Group>

                <Form.Group as={Row}>
                    <Form.Label column sm={4} md={3}>統編：</Form.Label>
                    <Form.Label column sm={8} md={9}>{userData ? userData.inc_no : ""}</Form.Label>
                </Form.Group>

                <Form.Group as={Row}>
                    <Form.Label column sm={4} md={3}>購買方案：</Form.Label>
                    <Form.Label column sm={8} md={9}>{getType()}</Form.Label>
                </Form.Group>

                <Form.Group as={Row}>
                    <Form.Label column sm={4} md={3}>使用期限：</Form.Label>
                    <Form.Label column sm={8} md={9}>{getInterval()}</Form.Label>
                </Form.Group>

                {isAdmin == Enums.E_ADMIN.NORMAL ? (
                    <Form.Group as={Row}>
                        <Form.Label column sm={4} md={3}>剩餘點數：</Form.Label>
                        <Form.Label column sm={8} md={9}>{userData ? userData.platform_point : ""}</Form.Label>
                    </Form.Group>
                ) : null}

                {isAdmin == Enums.E_ADMIN.NORMAL ? (
                    <Form.Group as={Row} controlId="formHorizontalDeposit">
                        <Form.Label column sm={{ span: 4, offset: 4 }} md={{ span: 4, offset: 0 }}><Link to="/charge/index">儲值方案</Link></Form.Label>
                    </Form.Group>
                ) : null}
            </Form>
        )
    }

    function onPwdAttrUpdate(attr, data) {
        let tmp = { ...pwdTmpData }
        tmp[attr] = data;
        setPwdTmpData(tmp);
        console.log(tmp);
    }

    function onHidePwd() { setIsShowPwdPanel(false) }
    function renderPwdPanel() {
        return (
            <Modal show={isShowPwdPanel} onHide={onHidePwd}>
                <Modal.Header closeButton>
                    <Modal.Title>更改密碼</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form>
                            <Form.Group>
                                <Form.Label>舊密碼：</Form.Label>
                                <Form.Control type="password"
                                    value={pwdTmpData ? pwdTmpData.old_password : ""}
                                    onChange={(e) => onPwdAttrUpdate("old_password", e.target.value)} />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>新密碼：</Form.Label>
                                <Form.Control type="password"
                                    value={pwdTmpData ? pwdTmpData.new_password : ""}
                                    onChange={(e) => onPwdAttrUpdate("new_password", e.target.value)} />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>新密碼：</Form.Label>
                                <Form.Control type="password"
                                    value={pwdTmpData ? pwdTmpData.new_password_again : ""}
                                    onChange={(e) => onPwdAttrUpdate("new_password_again", e.target.value)} />
                            </Form.Group>
                        </Form>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHidePwd}>
                        取消
                    </Button>
                    <Button variant="primary" onClick={onPwdSend}>
                        確定變更
                    </Button>
                </Modal.Footer>
            </Modal>);
    }

    function onHideMobile() { setIsShowMobilePanel(false) }
    function renderMobilePanel() {
        return (<Modal show={isShowMobilePanel} onHide={onHideMobile}>
            <Modal.Header closeButton>
                <Modal.Title>新增手機：</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Form>
                        <Form.Group>
                            <Form.Label>手機號碼清單</Form.Label>
                            <Form.Control type="test"
                                value={tmpMobile ? tmpMobile : ""}
                                onChange={(e) => setTmpMobile(e.target.value)} />
                            <Form.Text className="text-muted">
                                請以","分隔, 勿加空白
                            </Form.Text>
                        </Form.Group>
                    </Form>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHideMobile}>
                    取消
                </Button>
                <Button variant="primary" onClick={onMobileSend}>
                    確定變更
                </Button>
            </Modal.Footer>
        </Modal>);
    }

    function renderTransactionRecord() {
        let tmp = [];
        transactionRecord.forEach((val, index) => {
            tmp.push(
                <tr key={index}>
                    <td>{Tools.getFormatDateTime(val.created_at)}</td>
                    <td>{val.name}</td>
                    <td>{val.platform_point}</td>
                    <td>{val.cash}</td>
                </tr>
            );
        });

        return (
            <div>
                <Table striped bordered hover className="mt-4">
                    <thead>
                        <tr>
                            <th>日期時間</th>
                            <th>項目</th>
                            <th>點數</th>
                            <th>現金(新台幣)</th>
                        </tr>
                    </thead>
                    <tbody>{tmp}
                    </tbody>
                </Table>
                <div className="mt-2 text-right">
                    <div className="btn btn-danger interact-disabled">小計：目前剩餘{userData ? userData.platform_point : ""}點</div>
                </div>
            </div>
        )
    }

    function render() {
        return (
            <div className="container-fluid pb-4">
                <h2>我的帳戶</h2>
                {userData ? rednerUser() : null}
                <hr />
                <h2>公司資訊</h2>
                {userData ? rednerCompany() : null}
                {userData ? renderMobilePanel() : null}
                {userData ? renderPwdPanel() : null}
                <Button onClick={onClickTransactionRecord}>儲值紀錄</Button>
                {transactionRecord ? renderTransactionRecord() : null}
            </div>
        );
    }
    return render();
})